import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { handleGoogleLogin, ILoginState, login } from '@share/store/slices';

import img from '@assets/images/element/signin.svg';
import GoogleLoginComponent from '../google-auth/googleAuth';
import FacebookLoginComponent from '../facebook-auth/facebookAuth';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Routes } from '@share/constants';
import { Toaster } from '@share/utils';

import './style.scss';
import { push } from 'react-router-redux';

interface LOGIN {
  setUserData?: any;
}

const Login: React.FC<LOGIN> = () => {

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>(false);

  const dispatch = useDispatch();

  const { account } = useSelector((state: { loginStore: ILoginState }) => state.loginStore);

  const togglePasswordVisibility = (): void => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (event: any) => {
    event.preventDefault();
    dispatch(login(username, password, rememberMe));
  };
  
  const googleLogin = async (_user: any) => {
    try {
        dispatch(handleGoogleLogin(_user?.credential));
    }
    catch (error) {
      Toaster.error('Invalid credentials');
    }
  };

  const onGoogleLoginFiled = () => {
  };

  const handleSuccess = (_response: any) => {
  };

  const handleFailure = (_error: any) => {
  };

  return (
    <section className="log-in">
      <div className="container h-100 d-flex px-3 px-md-4 py-3 py-md-0">
        <div className="row justify-content-center align-items-center m-auto" style={{ width: '100%' }}>
          <div className="col-12">
            <div className="bg-mode shadow rounded-3 overflow-hidden">
              <div className="row g-0">
                <div className="col-lg-6 d-flex align-items-center order-2 order-lg-1">
                  <div className="p-3 p-lg-5">
                    <img src={img} alt="Login Side" />
                  </div>
                  <div className="vr opacity-1 d-none d-lg-block"></div>
                </div>

                <div className="col-lg-6 order-1">
                  <div className="p-sm-4 p-3 p-sm-7">
                    <h1 className="mb-2 h3"><FormattedMessage id="welcome.back" /></h1>
                    <p className="mb-0">
                      <FormattedMessage id="no.account" />
                      <span className='anchorBtn' onClick={() => dispatch(push(`/${account?.name}${Routes.Register}`))}> Register for free.</span>
                    </p>

                    <form className="mt-4 text-start" onSubmit={handleLogin}>
                      <div className="mb-3">
                        <label className="form-label"><FormattedMessage id="company.email" /></label>
                        <input
                          type="email"
                          className="form-control form-control-lg"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                        />
                      </div>
                      <div className="mb-3 position-relative">
                        <label className="form-label"><FormattedMessage id="account.password" /></label>
                        <input
                          className="form-control form-control-lg"
                          type={showPassword ? 'text' : 'password'}
                          id="psw-input"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          className="position-absolute top-50 end-0 translate-middle-y p-0 mt-3 toggle-password-login"
                          onClick={togglePasswordVisibility}
                        >
                          <i className={`fas ${showPassword ? 'fa-eye' : 'fa-eye-slash'} p-2`}></i>
                        </span>
                      </div>
                      <div className="mb-3 d-sm-flex justify-content-between">
                        <div>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="rememberCheck"
                            defaultChecked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                          />
                          <label className="form-check-label ms-2" htmlFor="rememberCheck">
                            <FormattedMessage id="remember" />
                          </label>
                        </div>
                        <Link to={`/${account?.name}${Routes.ForgotPassword}`}>
                          <FormattedMessage id="forgot.password" />?
                        </Link>
                      </div>
                      <button type="submit" className="btn btn-primary w-100 mb-3 mx-0">
                        <FormattedMessage id="login" />
                      </button>
                    </form>
                    <GoogleLoginComponent
                      extraClassName="commonBlueBtn"
                      onSuccess={googleLogin}
                      onFailed={onGoogleLoginFiled}
                    />
                    <FacebookLoginComponent onSuccess={handleSuccess} onFailed={handleFailure} extraClassName='commonBlueBtn'/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
